<template>

  <div v-if="refresh">

    <div v-if="tempMediaOnIndexDB.imageObj" class="parent">
    <mediaFileStory v-if="tempMediaOnIndexDB.imageObj"
      :mediaUrl=" this.tempMediaOnIndexDB.imageObj.media.formats.coverImageCenter? strapiUrl +'/uploads/'+ this.tempMediaOnIndexDB.imageObj.media.formats.coverImageCenter.hash + this.tempMediaOnIndexDB.imageObj.media.formats.coverImageCenter.ext:strapiUrl +'/uploads/'+ this.tempMediaOnIndexDB.imageObj.media.formats.small.hash + this.tempMediaOnIndexDB.imageObj.media.formats.small.ext"
      :type="'image'" :isLocal="false" :isThumbnail="true" />
      <v-btn @click="removeImageOnDB()" class="deletecovericon" small right fab>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div v-else>
  <div class="labelOverImage">
      <v-file-input v-if="imageBlob==null" ref="uploadImage" class="pl-a pr-a pt-0 pl-a pr-a imageplaceholder"
        prepend-icon="mdi-camera-plus"  accept="image/*" hide-input v-model="imageBlob" @change="uploadImageFiles"> upload
      </v-file-input>
<div class="centered">{{$t('upload')}}</div>

  </div>      
    </div>
  </div>
</template>

<script>
import mediaFileStory from "@/components/mediaFileStory.vue";

export default {
  name: 'uploadMediaCoverImage',
  components: {
    mediaFileStory
  },
  data() {

    return {
      apiUrl: process.env.VUE_APP_ROOT_API,

      strapiUrl: process.env.VUE_APP_ROOT_STRAPI,
      maxImgFileSize: 10000000,
      imageBlob: null,
      refresh: true,
      coverImageCrop:null
    }
  },
  async mounted() {

    if (this.tempMediaOnIndexDB.imageTitle != null && this.tempMediaOnIndexDB.imageTitle != "") {
      this.refresh=false
      this.refresh=true

    }
  },
  watch: {
    'tempMediaOnIndexDB.imageTitle': function () {
      if (this.tempMediaOnIndexDB.imageTitle != null && this.tempMediaOnIndexDB.imageTitle != "") {
      console.log("change")
      }
    }
  },
  computed: {
    getUser: {
        get: function () {
          return this.$store.getters.getUser;
        }
      },
    tempMediaOnIndexDB: {
      get: function () {
        return this.$store.state.tempMediaOnIndexDB
      },
      set: function (newValue) {
        this.$store.dispatch("setTempMediaOnIndexDB", newValue)
      }
    }
  },
  methods: {
        removeImage() {
      this.$store.dispatch("setDialogPreUpload",{color:'',text:'',active:false,isSuccess:false}),
      this.$store.dispatch("addimageObjOntempMediaOnIndexDB", null)
      this.$store.dispatch("addImageTitleOntempMediaOnIndexDB", "")
      this.$store.dispatch("addImageSizeOntempMediaOnIndexDB", null)
      this.$store.dispatch("addImageIDOntempMediaOnIndexDB", null)
      this.imageBlob = null
    },
    async removeImageOnDB() {
      try {
        this.removeImage()
        this.$store.dispatch('setLoading',true)
        //remove immage
        //let completeurl =  this.apiUrl + '/test'
        //let temp
        //temp = await this.getaxiosResponse(completeurl)
        //console.log('temp',temp)
        this.$store.dispatch('setLoading',false)

      } catch (error) {
        console.log(error);
      }
  },
    async uploadImage() {
      this.coverImageCrop = await this.uploadImageFiles()
    }
    ,
    async uploadImageFiles() {
        //if imageID is != null there is the image in the DB
        if (this.tempMediaOnIndexDB.imageID != null) {
          return this.tempMediaOnIndexDB.imageID
        }
        if (this.tempMediaOnIndexDB.imageID == null || (typeof this.imageBlob.name !='undefined' && typeof this.imageBlob.file !='undefined')) {
          try {
            let form_data = new FormData();
            form_data.append('files', this.imageBlob)
            let uploadedFile = (await this.$axios.post(this.strapiUrl+"/upload",
              form_data, {
                headers: {
                  "Authorization": `Bearer ${this.$store.getters.getAccessToken}`,
                  'Content-Type': 'multipart/form-data',
                }
              },
            )).data[0];

            let imageResponse = await this.$axios.post(this.apiUrl+"/postMediaFile", {
              "type": uploadedFile.mime.split("/")[0],
              "title": uploadedFile.name,
              "description": null,
              "user": parseInt(this.getUser.id, 10),
              "media": uploadedFile.id
            }, {
              headers: {
                "x-access-token": `Bearer ${this.$store.getters.getAccessToken}`
              }
            })

          await this.$store.dispatch("addimageObjOntempMediaOnIndexDB", imageResponse.data)
// salvare il nuovo temp id su tempMediaOnIndexDB
            return imageResponse.data
          } catch (error) {
                        this.$store.dispatch('setLoadingStory', {status:false,text:''})
            console.error(error)
            if (Object.prototype.hasOwnProperty.call(error.response.data.message[0], 'messages')) {
              throw error.response.data.message[0].messages[0].message;
            }
            throw error.response.data.message
          }
        }

      }
    },
    //retrieves blob file from indexdb
    getFileFromIndexDB: function (name) {
      return this.$indexdb.mediaFiles.where("name").equalsIgnoreCase(name).toArray()
    },
}
</script>
<style scope>
/* Centered text */
.centered {
  -webkit-user-select: none; /* Safari */
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* IE10+/Edge */
user-select: none; /* Standard */

  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.labelOverImage{
  position: relative;
  text-align: center;
  color: black;
}

.pl-a > div:nth-child(1){
  margin: auto;
}
.mdi.mdi-camera-plus{
  min-height: 4rem;
  font-size: 3rem;
  margin-left: auto;
  margin-right: auto;
  min-width: 100vw;
}
.v-responsive__content{
  width: 100%!important;
}
.imageplaceholder{
  background-repeat: no-repeat;
  height:32vw;
  width: 100vw;
  margin-right: auto;
  margin-left: auto;
  background-color: #EEE !important;
  min-height: 110px;
}
.parent {
  position: relative;
  top: 0;
  left: 0;
}
.deletecovericon{
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;

}
.previewCoverImage{
  width: 100%;
  height: auto;
}


.file-upload {
  background-color: #ffffff;
  width: 600px;
  margin: 0 auto;
  padding: 20px;
}

.file-upload-btn {
  width: 100%;
  margin: 0;
  color: #fff;
  background: #1FB264;
  border: none;
  padding: 10px;
  border-radius: 4px;
  border-bottom: 4px solid #15824B;
  transition: all .2s ease;
  outline: none;
  text-transform: uppercase;
  font-weight: 700;
}






.remove-image {
  width: 200px;
  margin: 0;
  color: #fff;
  background: #cd4535;
  border: none;
  padding: 10px;
  border-radius: 4px;
  border-bottom: 4px solid #b02818;
  transition: all .2s ease;
  outline: none;
  text-transform: uppercase;
  font-weight: 700;
}

.remove-image:hover {
  background: #c13b2a;
  color: #ffffff;
  transition: all .2s ease;
  cursor: pointer;
}

.remove-image:active {
  border: 0;
  transition: all .2s ease;
}
</style>